module.exports = __webpack_public_path__ + "static/media/04_tn.843909a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/04_tn.jpg
// module id = 313
// module chunks = 0